var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMaterialSupervisorAccount = function SvgIconMaterialSupervisorAccount(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.52,
    height: 21,
    viewBox: "0 0 30.52 21",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-supervisor-account",
    "data-name": "Icon material-supervisor-account",
    d: "M25.127,18a3.751,3.751,0,1,0-3.815-3.75A3.771,3.771,0,0,0,25.127,18ZM13.682,16.5A4.5,4.5,0,1,0,9.1,12,4.52,4.52,0,0,0,13.682,16.5ZM25.127,21c-2.793,0-8.393,1.38-8.393,4.125V28.5H33.52V25.125C33.52,22.38,27.92,21,25.127,21ZM13.682,19.5C10.126,19.5,3,21.255,3,24.75V28.5H13.682V25.125c0-1.275.5-3.51,3.617-5.205A19.055,19.055,0,0,0,13.682,19.5Z",
    transform: "translate(-3 -7.5)",
    fill: "#bcbcbc"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMaterialSupervisorAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icon material-supervisor-account.82721cd9b3d2eeb153e612ca99211c10.svg";